// extracted by mini-css-extract-plugin
module.exports = {"arrow__icon__block":"arrowIcon_arrow__icon__block__3iunV","arrow__icon":"arrowIcon_arrow__icon__3VzF1"};